import React, { Component } from "react";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./dark.css";
import { ImageDecorator, findImageEntities, findLinkEntities, LinkDecorator, findEmbeddedLinkEntities, EmbeddedLinkDecorator } from "./decorators";

var ReactEditor = function ReactEditor(props) {
  // console.log("ReactEditor", props);
  var onEditorStateChange = function onEditorStateChange(editorState) {
    // console.log("ReactEditor editorState", editorState);
    var aux = draftToHtml(convertToRaw(editorState.getCurrentContent())); // console.log("ReactEditor aux", aux);

    props.handleEditorChange(editorState, aux);
  };

  return /*#__PURE__*/React.createElement("div", {
    style: {
      borderRadius: "8px",
      backgroundColor: "#424242",
      color: "#fff",
      padding: "16px"
    }
  }, /*#__PURE__*/React.createElement(Editor, {
    editorState: props.editorState ? props.editorState : EditorState.createEmpty(),
    wrapperClassName: "demo-wrapper",
    editorClassName: props.classEditor || "demo-editor",
    onEditorStateChange: onEditorStateChange,
    customDecorators: [// { strategy: findImageEntities, component: ImageDecorator },
      // {
      //   strategy: findEmbeddedLinkEntities,
      //   component: EmbeddedLinkDecorator
      // }
    ]
  }));
};

export { ReactEditor };